<!-- Floating left menu -->
<div #leftContainer id="left-menu-component" (scroll)="updatePositioning()">
    <sit-icon-button [icon]="Icon.menu_ng" [sizeClass]="'icon-size-32'" class="left-menu-toggler"
        [ngClass]="{reloc: opened}" style="width: 64px;" [colorClass]="'text-color-white'"
        (click)="handleToggleMenu()" />
    <div *ngFor="let item of menuItems" class="left-item-menu" matTooltip="{{item.tag}}"
        (mouseenter)="handleMouseEnter($event)" (mouseleave)="handleMouseLeave($event)" matTooltipPosition="above">
        <button class="left-item-menu-btn" (click)="dispatchEvent(item.dispatcher$, item.event)"
            [ngClass]="{activeItem: (activeItem$ | async) === item.event?.action}">
            <sit-icon [icon]="item.icon" format="svg" [sizeClass]="'icon-size-32'"
                hoverClass="icon-hover-complementary-2"></sit-icon>
            <div #sublist class="left-item-menu-sublist">
                <button *ngFor="let subitem of item.submenus"
                    (click)="dispatchEvent(subitem.dispatcher$, subitem.event)" class="left-item-menu-sublist-element"
                    [ngClass]="{activeItem: (activeItem$ | async) === subitem.event?.action}"
                    [matTooltip]="subitem.tag">
                    <sit-icon [icon]="subitem.icon" format="svg" [sizeClass]="'icon-size-32'"></sit-icon>
                </button>
            </div>
        </button>
    </div>
</div>

<!-- Responsive left menu -->
<div id="responsive-left-menu-component" [ngClass]="{opened}">
    <div class="left-menu-account">
        <sit-icon [icon]="Icon.user_y" sizeClass="icon-size-40" format="svg" colorClass="icon-fill-primary-1" />
        <div style="display: flex; flex-direction: column;">
            <span> Luisa Otero</span>
            <span> luisaotero@gmail.com</span>
        </div>
        <sit-icon-button style="margin-left: auto;" [sizeClass]="'icon-size-40'" [icon]="Icon.dots" />
    </div>
    <ng-container *ngFor="let item of menuItems">
        <div *ngIf="item.submenus?.length; then composedMenu else simpleMenu"></div>
        <ng-template #composedMenu>
            <details>
                <summary>
                    <sit-icon [icon]="item.icon" sizeClass="icon-size-40" format="svg"
                        colorClass="icon-fill-primary-1" />
                    {{item.tag}}
                </summary>
                <button *ngFor="let submenu of item.submenus" class="details-submenu"
                    (click)="dispatchEvent(submenu.dispatcher$, submenu.event)">
                    <sit-icon [icon]="submenu.icon" sizeClass="icon-size-40" format="svg"
                        colorClass="icon-fill-primary-1" />

                    {{submenu.tag}}
                </button>
            </details>
        </ng-template>
        <ng-template #simpleMenu>
            <button class="details-submenu" (click)="dispatchEvent(item.dispatcher$, item.event)">
                <sit-icon [icon]="item.icon" sizeClass="icon-size-40" format="svg" colorClass="icon-fill-primary-1" />
                {{item.tag}}
            </button>
        </ng-template>
    </ng-container>
    <div class="left-menu-footer">
        <button>Notificaciones</button>
        <button>Administración</button>
        <section class="left-menu-footer-logos">
            <sit-icon [icon]="Icon.logo_menu_almeria" [alt]="'Icono de Almeria'" [tooltip]="'Icono de alemria'"
                [sizeClass]="'icon-size-120'"></sit-icon>
            <sit-icon [icon]="Icon.logo_union_europea" [alt]="'Icono de Union Europea'" [tooltip]="'Icono de Hora'"
                [sizeClass]="'icon-size-120'"></sit-icon>
        </section>
    </div>
</div>